// extracted by mini-css-extract-plugin
export default {"inputRoot":"DateRangeController_inputRoot__w0jbq","arrowIcon":"DateRangeController_arrowIcon__mDR5f"};